(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Responsive-her-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('responsive-shopify-hero')) {
    customElements.define('responsive-shopify-hero', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const expanded = event.target.closest('details[open]');
          if (!expanded || !this.contains(expanded)) return;
          expanded.open = false;
          expanded.querySelector('summary')?.focus();
          event.stopPropagation();
        }, options);
        this.addEventListener('click', (event) => {
          if (!event.target.closest('a')) return;
          this.querySelectorAll('details[open]').forEach((details) => { details.open = false; });
        }, options);
        document.addEventListener('click', (event) => {
          if (this.contains(event.target)) return;
          this.querySelectorAll('details[open]').forEach((details) => { details.open = false; });
        }, options);
        const desktop = window.matchMedia('(min-width: 990px)');
        desktop.addEventListener('change', () => {
          this.querySelectorAll('details[open]').forEach((details) => { details.open = false; });
        }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
